import { formatUtcDateTime } from '../../services/caseCanvas';
import type { BucketTotals, TokenAmounts } from './types';

export function shortAddress(a: string | null | undefined): string {
  if (!a) return '';
  return a.length > 14 ? `${a.slice(0, 6)}…${a.slice(-6)}` : a;
}

export function formatAmount(n: number): string {
  if (!Number.isFinite(n)) return '0';
  const abs = Math.abs(n);
  return n.toLocaleString('en-US', { maximumFractionDigits: abs >= 100 ? 0 : 2 });
}

/** "12,000 USDT · 40 TRX": one figure per token, never summed across tokens. */
export function formatByToken(t: TokenAmounts | null | undefined): string {
  const entries = Object.entries(t || {}).filter(([, v]) => Number(v) > 0);
  entries.sort((a, b) => Number(b[1]) - Number(a[1]));
  return entries.map(([tok, v]) => `${formatAmount(Number(v))} ${tok}`).join(' · ');
}

/**
 * The one money line of a bucket, shared by the canvas subtitle and the report card so the same
 * bucket never prints a different figure: money IN is preferred (as the report states it), money
 * OUT is the fallback, and the line always names the direction ("in 36,835,529 USDT").
 */
export function bucketMoneyLine(t: Pick<BucketTotals, 'in_by_token' | 'out_by_token'> | null | undefined): string {
  const inn = formatByToken(t?.in_by_token);
  if (inn) return `in ${inn}`;
  const out = formatByToken(t?.out_by_token);
  return out ? `out ${out}` : '';
}

export function formatTs(ts: string | number | null | undefined): string {
  if (ts === null || ts === undefined || ts === '') return 'not recorded';
  return formatUtcDateTime(ts) ?? 'not recorded';
}
